module.exports = __webpack_public_path__ + "static/media/megamarket_200x400.18194f72.jpg";